import {
  blackColor,
  dangerColor,
  // boxShadow,
  defaultFont,
  drawerWidth,
  grayColor,
  hexToRgb,
  infoColor,
  primaryBoxShadow,
  primaryColor,
  successColor,
  transition,
  warningColor,
  whiteColor,
} from "assets/jss/material-dashboard-react.js";
import { callingCodes } from "country-data";

const smallMenuWidth = "75px"
const largeMenuWidth = "100px"
const inputBackgroundColor = '#ebebeb'
const inputBackgroundPadding = 10

const defaultInputAppearance = {
  padding: inputBackgroundPadding,
  backgroundColor: inputBackgroundColor
}
const subMenuStyles = {
  display: "flex",
  paddingTop: 6,
  color: '#7a7a76',
  paddingBottom: 2,
  fontSize: 12.5,
  fontWeight: "500",
  cursor: "pointer",
  width: smallMenuWidth,
};

const sidebarStyle = (theme) => {
  return {
    filterdrawerPaper: {
      position: "fixed",
      top: "0",
      bottom: "0",
      overflow: "hidden",
      flexShrink: 0,
      zIndex: 9999,
      background: "white",
      color: "#7A7A7A",
      borderTop: "none",
      border: "1px solid white",
      width: drawerWidth,
      [theme.breakpoints.up("md")]: {
        width: drawerWidth,
        position: "fixed",
        height: "100%",
      },
      [theme.breakpoints.down("sm")]: {
        width: drawerWidth,
        // ...boxShadow,
        position: "",
        display: "block",
        top: "0",
        height: "100vh",
        right: "0",
        left: "auto",
        zIndex: "1032",
        visibility: "visible",
        overflowY: "visible",
        borderTop: "none",
        textAlign: "left",
        paddingRight: "0px",
        paddingLeft: "0",
        transform: `translate3d(${drawerWidth}px, 0, 0)`,
        ...transition,
      },
    },
    gallery: {
      width: 130,
      display: "flex",
      paddingLeft: 15,
      paddingTop: 8,
      color: "#7A7A7A",
      paddingBottom: 2,
      fontSize: 12,
      fontWeight: "600",
      cursor: "pointer",
      // width: smallMenuWidth,
    },
    drawerPaper: {
      position: "fixed",
      top: "0",
      bottom: "0",
      overflow: "hidden",
      flexShrink: 0,
      zIndex: 9999,
      backgroundColor: "#ededed",
      color: "#7A7A7A",
      borderTop: "none",
      border: "10px solid white",
      // ...boxShadow,
      width: drawerWidth,
      [theme.breakpoints.up("md")]: {
        width: drawerWidth,
        // position: "fixed",
        height: "100%",
        backgroundColor: "#ededed",
        marginTop: "40px",
      },
      [theme.breakpoints.down("sm")]: {
        width: drawerWidth,
        // ...boxShadow,
        position: "",
        display: "block",
        top: "0",
        height: "100vh",
        right: "0",
        left: "auto",
        zIndex: "1032",
        visibility: "visible",
        overflowY: "visible",
        borderTop: "none",
        textAlign: "left",
        paddingRight: "0px",
        paddingLeft: "0",
        transform: `translate3d(${drawerWidth}px, 0, 0)`,
        ...transition,
      },
    },
    toolbar: theme.mixins.toolbar,
    dragger: {
      width: "5px",
      cursor: "ew-resize",
      padding: "4px 0 0",
      borderTop: "1px solid #ddd",
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      zIndex: 100,
      // backgroundColor: "#f4f7f9",
    },
    drawerPaperRTL: {
      [theme.breakpoints.up("md")]: {
        left: "auto !important",
        right: "0 !important",
      },
      [theme.breakpoints.down("sm")]: {
        left: "0  !important",
        right: "auto !important",
      },
    },
    logo: {
      position: "relative",
      padding: "15px 15px",
      zIndex: "4",
      "&:after": {
        content: '""',
        position: "absolute",
        bottom: "0",

        height: "1px",
        right: "15px",
        width: "calc(100% - 30px)",
        backgroundColor: "rgba(" + hexToRgb(grayColor[6]) + ", 0.3)",
      },
    },
    logoLink: {
      ...defaultFont,
      textTransform: "uppercase",
      padding: "5px 0",
      display: "block",
      fontSize: "18px",
      textAlign: "left",
      fontWeight: "400",
      lineHeight: "30px",
      textDecoration: "none",
      backgroundColor: "transparent",
      "&,&:hover": {
        color: whiteColor,
      },
    },
    logoLinkRTL: {
      textAlign: "right",
    },
    logoImage: {
      width: "30px",
      display: "inline-block",
      maxHeight: "30px",
      marginLeft: "10px",
      marginRight: "15px",
    },
    img: {
      width: "35px",
      top: "22px",
      position: "absolute",
      verticalAlign: "middle",
      border: "0",
    },
    background: {
      position: "absolute",
      zIndex: "1",
      height: "100%",
      width: "100%",
      display: "block",
      top: "0",
      left: "0",
      backgroundSize: "cover",
      backgroundPosition: "center center",
      "&:after": {
        position: "absolute",
        zIndex: "3",
        width: "100%",
        height: "100%",
        content: '""',
        display: "block",
        background: blackColor,
        opacity: ".8",
      },
    },
    list: {
      marginTop: "5px",
      paddingLeft: "0",
      paddingTop: "0",
      paddingBottom: "0",
      marginBottom: "0",
      listStyle: "none",
      position: "unset",
      backgroundColor: "#ededed",
    },
    item: {
      position: "relative",
      display: "block",
      textDecoration: "none",
      "&:hover,&:focus,&:visited,&": {
        color: whiteColor,
      },
    },
    itemLink: {
      width: "auto",
      transition: "all 300ms linear",
      // margin: "10px 15px 0",
      borderRadius: "3px",
      position: "relative",
      display: "block",
      // padding: "10px 15px",
      backgroundColor: "transparent",
      ...defaultFont,
    },
    itemIcon: {
      width: "24px",
      height: "30px",
      fontSize: "24px",
      lineHeight: "30px",
      float: "left",
      marginRight: "15px",
      textAlign: "center",
      verticalAlign: "middle",
      color: "#7A7A7A",
    },
    itemWhiteIcon: {
      width: "24px",
      height: "30px",
      fontSize: "24px",
      lineHeight: "30px",
      float: "left",
      marginRight: "15px",
      textAlign: "center",
      verticalAlign: "middle",
      color: "white",
    },
    itemIconRTL: {
      marginRight: "3px",
      marginLeft: "15px",
      float: "right",
    },
    itemText: {
      ...defaultFont,
      margin: "0",
      fontFamily: "Helvetica",
      lineHeight: "30px",
      fontSize: "18px",
      color: "#7A7A7A",
    },
    itemWhiteText: {
      ...defaultFont,
      margin: "0",
      fontFamily: "Helvetica",
      lineHeight: "30px",
      fontSize: "18px",
      color: "white",
    },
    itemTextRTL: {
      textAlign: "right",
    },
    whiteFont: {
      color: whiteColor,
    },
    purple: {
      backgroundColor: primaryColor[0],
      ...primaryBoxShadow,
      "&:hover,&:focus": {
        backgroundColor: primaryColor[0],
        ...primaryBoxShadow,
      },
    },
    blue: {
      backgroundColor: infoColor[0],
      boxShadow:
        "0 12px 20px -10px rgba(" +
        hexToRgb(infoColor[0]) +
        ",.28), 0 4px 20px 0 rgba(" +
        hexToRgb(blackColor) +
        ",.12), 0 7px 8px -5px rgba(" +
        hexToRgb(infoColor[0]) +
        ",.2)",
      "&:hover,&:focus": {
        backgroundColor: infoColor[0],
        boxShadow:
          "0 12px 20px -10px rgba(" +
          hexToRgb(infoColor[0]) +
          ",.28), 0 4px 20px 0 rgba(" +
          hexToRgb(blackColor) +
          ",.12), 0 7px 8px -5px rgba(" +
          hexToRgb(infoColor[0]) +
          ",.2)",
      },
    },
    green: {
      backgroundColor: successColor[0],
      boxShadow:
        "0 12px 20px -10px rgba(" +
        hexToRgb(successColor[0]) +
        ",.28), 0 4px 20px 0 rgba(" +
        hexToRgb(blackColor) +
        ",.12), 0 7px 8px -5px rgba(" +
        hexToRgb(successColor[0]) +
        ",.2)",
      "&:hover,&:focus": {
        backgroundColor: successColor[0],
        boxShadow:
          "0 12px 20px -10px rgba(" +
          hexToRgb(successColor[0]) +
          ",.28), 0 4px 20px 0 rgba(" +
          hexToRgb(blackColor) +
          ",.12), 0 7px 8px -5px rgba(" +
          hexToRgb(successColor[0]) +
          ",.2)",
      },
    },
    orange: {
      backgroundColor: warningColor[0],
      boxShadow:
        "0 12px 20px -10px rgba(" +
        hexToRgb(warningColor[0]) +
        ",.28), 0 4px 20px 0 rgba(" +
        hexToRgb(blackColor) +
        ",.12), 0 7px 8px -5px rgba(" +
        hexToRgb(warningColor[0]) +
        ",.2)",
      "&:hover,&:focus": {
        backgroundColor: warningColor[0],
        boxShadow:
          "0 12px 20px -10px rgba(" +
          hexToRgb(warningColor[0]) +
          ",.28), 0 4px 20px 0 rgba(" +
          hexToRgb(blackColor) +
          ",.12), 0 7px 8px -5px rgba(" +
          hexToRgb(warningColor[0]) +
          ",.2)",
      },
    },
    red: {
      backgroundColor: dangerColor[0],
      boxShadow:
        "0 12px 20px -10px rgba(" +
        hexToRgb(dangerColor[0]) +
        ",.28), 0 4px 20px 0 rgba(" +
        hexToRgb(blackColor) +
        ",.12), 0 7px 8px -5px rgba(" +
        hexToRgb(dangerColor[0]) +
        ",.2)",
      "&:hover,&:focus": {
        backgroundColor: dangerColor[0],
        boxShadow:
          "0 12px 20px -10px rgba(" +
          hexToRgb(dangerColor[0]) +
          ",.28), 0 4px 20px 0 rgba(" +
          hexToRgb(blackColor) +
          ",.12), 0 7px 8px -5px rgba(" +
          hexToRgb(dangerColor[0]) +
          ",.2)",
      },
    },
    sidebarWrapper: {
      position: "relative",
      height: "auto",
      overflow: "auto",
      zIndex: "4",
      overflowScrolling: "touch",
    },
    activePro: {
      [theme.breakpoints.up("md")]: {
        position: "absolute",
        width: "100%",
        bottom: "13px",
      },
    },
    paper: {
      position: "absolute",
      width: "30%",
      border: "2px solid #000",
      borderRadius: 20,
      boxShadow: theme.shadows[5],
      backgroundColor: "white",
    },
    laptoppad: {
      position: "absolute",
      width: "40%",
      border: "2px solid #000",
      borderRadius: 20,
      boxShadow: theme.shadows[5],
      backgroundColor: "white",
    },
    ipadpaper: {
      position: "absolute",
      width: "63%",
      border: "2px solid #000",
      borderRadius: 20,
      boxShadow: theme.shadows[5],
      backgroundColor: "white",
    },
    mainPoint: {
      backgroundColor: "#E8F0FD",
    },
    subMenu: {
      ...subMenuStyles,
    },
    eventCommissionSplitSubMenuKey: {
      ...subMenuStyles,
      width: 210,
      color: "#7a7a76",
      fontSize: "12.5px",
    },
    eventComissionSplitSubMenuValue: {
      marginLeft: 20,
    },
    discountSubMenu: {
      marginLeft: 10
    },
    priceSubMenu: {
      marginLeft: 10
    },
    facialRecognitionIncludedSubMenu: {
      ...subMenuStyles,
      top: 4,
      width: 270,
      position: 'relative'
    },
    facialRecognitionIncludedCheckbox: {
      bottom: 8,
      right: 3,
      position: 'relative'
    },
    subMenuExtended: {
      ...subMenuStyles,
      width: largeMenuWidth,
    },
    addRecognition: {
      display: "flex",
      paddingLeft: 15,
      paddingTop: 8,
      color: "#7A7A7A",
      paddingBottom: 2,
      fontSize: 12,
      fontWeight: "600",
      cursor: "pointer",
    },
    addRecognitionRadio: {
      bottom: 9,
      marginRight: '15px',
      position: 'relative'
    },
    eventCommissionSplit: {
      display: "flex",
      paddingLeft: 15,
      paddingTop: 8,
      color: "#7A7A7A",
      paddingBottom: 2,
      fontSize: 12,
      fontWeight: "600",
      cursor: "pointer",
    },
    eventCommissionSplitField: {
      bottom: 5,
      right: 24,
      position: 'relative',
      '& input[type=number]': {
        '-moz-appearance': 'textfield'
      },
      '& input[type=number]::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      },
      '& input[type=number]::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      },
    },
    subMenu7: {
      marginLeft: "20px",
      paddingTop: 10,
      fontSize: 12,
      fontWeight: "600",
      color: "#7A7A7A",
    },
    subMenu8: {
      marginLeft: "20px",
      paddingTop: 10,
      fontSize: 12,
      fontWeight: "600",
      color: "blue",
      "&::placeholder": {
        color: "blue",
      },
    },
    subMenu2: {
      paddingLeft: 15,
      paddingTop: 10,

      color: "#7A7A7A",
      textAlign: "center",
      paddingBottom: 3,
      fontWeight: "600",
      cursor: "pointer",
      "&:hover,&:focus": {
        backgroundColor: "#1da1f2",
        color: "white",
        ...primaryBoxShadow,
      },
    },
    subMenu3: {
      display: "flex",
      paddingLeft: 5,
      paddingTop: 0,
      color: "#7A7A7A",
      paddingBottom: 10,
      fontSize: 15,
      fontWeight: "400",
      cursor: "pointer",
    },
    filter: {
      fontSize: 16,
    },
    galleryView: {
      textAlign: "center",
      fontSize: "16px",
    },
    treeGallery: {
      display: "flex",
      paddingBottom: 10,
      cursor: "pointer",
      textAlign: "left",
      paddingLeft: 5,
      paddingTop: 0,
      color: "#7A7A7A",
      fontSize: 15,
      fontWeight: "400",
      "& span": {
        marginLeft: 10,
      },
      "&:hover,&:focus": {
        backgroundColor: "#1da1f2",
        color: "white",
        ...primaryBoxShadow,
      },
    },
    galleryHeader: {
      paddingLeft: 20,
      display: "flex",
      color: "white",
      fontSize: 18,
      fontWeight: "500",
      width: "100%",
      alignItems: "center",
      cursor: "pointer",
      "&:hover,&:focus": {
        backgroundColor: "#00acc1",
        ...primaryBoxShadow,
      },
    },
    gallerySubMenuHeading: {
      width: "100%",
      fontWeight: 700,
      color: "#0b3556",
      fontSize: 13,
      margin: "12px 0px 6px",
      paddingBottom: 6,
      borderBottom: "2px solid #d8e7f5",
      textDecoration: "none",
      display: "flex",
      alignItems: "center",
    },
    gallerySubMenuKey: {
      width: "auto",
      marginTop: 10,
      fontSize: 12,
      fontWeight: 700,
      color: "#0b3556",
    },
    galleryEventSubMenuKey: {
      width: 120,
      marginTop: 7,
    },
    gallerySubMenuValue: {
      width: 180,
      marginTop: 7,
    },
    galleryPasswordWrapper: {
      marginTop: 0,
      display: 'flex'
    },
    galleryEventSubMenuKeyPassword: {
      width: 120,
    },
    galleryPasswordVisibilityToggle: {
      left: 10,
      width: 1,
      position: 'relative'
    },
    galleryPassword: {
      width: 145,
      border: 'none',
      background: 'transparent'
    },
    currencyName: {
      color: '#7a7a76',
      fontWeight: 400,
    },
    box: {
      "&&&&": {
        display: "flex",
        alignItems: "end",
        justifyContent: "space-between",
      },
      "& :child": {
        width: "50%",
      },
      "& :first-child": {
        flexGrow: 1,
        flexBasis: "50%",
      },
      "& :last-child": {
        flexGrow: 2,
        flexBasis: "50%",
      },
    },
    sidebarHeading: {
      margin: "-1px -1px 0 -1px",
      fontSize: 15,
      minHeight: 46,
      fontWeight: 700,
      display: "flex",
      color: "#ffffff",
      lineHeight: "1.3",
      padding: "14px 18px",
      textAlign: "left",
      alignItems: "center",
      background: "#0b3556",
      fontFamily: "inherit",
      flexShrink: 0,
      borderRadius: "14px 14px 0 0",
    },
    galleryEditorSideBarHeading: {
      width: '100%',
      margin: 0,
      background: "#0b3556",
      borderRadius: 0,
    },
    rightSideBarWrapper: {
      margin: 0,
      padding: "4px 0 10px",
      flex: 1,
      overflowY: "auto",
      overflowX: "hidden",
      "& .MuiTypography-root": {
        paddingTop: "0px",
      },
    },
    galleryFieldsWrapper: {
      width: '100%',
      padding: '0 20px',
      margin: 0,
    },
    uploadPhotosHeadingWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      padding: '0 20px',
      margin: 0,
      '& .bulk-upload-button': {
        opacity: 0,
        transition: 'opacity 0.2s ease-in-out',
      },
      '&:hover .bulk-upload-button': {
        opacity: 1,
      },
      '& .bulk-upload-button.in-progress': {
        opacity: 1,
      }
    },
    gallerySideBarFieldWrapper: {
      padding: "0 20px",
    },
    buttonWrapper: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "10px",
      marginTop: "4px",
      padding: "0 10px",
    },
    photographUploaderWrapper: {
      padding: '5px 0px',
      marginBottom: '15px'
    },
    grayButton: {
      backgroundColor: "#fff",
      color: "#4a4a48",
      border: "1px solid #d6e2ef",
      boxShadow: "none",
      "&:hover": {
        backgroundColor: "#f4f8fd",
        color: "#0b3556",
        border: "1px solid #3a86d8",
        boxShadow: "none",
      },
    },
    subMenu4: {
      color: "#0b3556",
      fontWeight: "600",
      fontSize: "13px",
      textAlign: "right",
      "& .makeStyles-container-47": {
        opacity: "0.30px",
      },
    },

    subMenu9: {
      color: "#000000",
      fontWeight: "800",
      fontSize: "12px",
      marginTop: "4px",
      textAlign: "left",
      width: "calc(100% - 110px)",
      ...defaultInputAppearance,
      "& .MuiInputBase-input": {
        padding: "0px",
      },
      "& .MuiTextField-root": {
        width: "100%",
      },
    },
    date: {
      color: "#000000",
      fontWeight: "800",
      fontSize: "12px",
      marginTop: "4px",
      textAlign: "left",
      ...defaultInputAppearance,
      width: "calc(100% - 110px)",
      "& .MuiInputBase-input": {
        padding: "0px",
      },
      "& .MuiTextField-root": {
        width: "98%",
      },
    },
    event: {
      color: "#000000",
      fontWeight: "600",
      fontSize: "12px",
      marginTop: "2px",
      textAlign: "left",
      width: "calc(100% - 110px)",
      "& .MuiInputBase-input": {
        padding: "0px",
      },
    },
    gallery_activity_form_field: {
      color: "#000000",
      fontWeight: "600",
      fontSize: "12px",
      display: "flex",
      flexWrap: "wrap",
      gap: "5px",
      top: 5,
      position: 'relative',
      width: "100% !important",
//      ...defaultInputAppearance,
      "& .MuiInputBase-input": {
        padding: "0px",
      },
      "& svg": {
        bottom: 0,
        left: '93%',
        position: 'absolute'
      }
    },
    sport: {
      top: 2,
      position: 'relative',
      color: "#000000",
      fontWeight: "600",
      fontSize: "12px",
      display: "flex",
      flexWrap: "wrap",
      gap: "5px",
      width: "195px",
      width: '100%',
      "& .MuiInputBase-input": {
        padding: "0px",
      },
    },
    event2: {
      fontWeight: "600",
      width: "100%",
      color: "#7A7A7A",
      fontSize: 12,
      marginLeft: "-85px",
    },

    location: {
      color: "#000000",
      fontWeight: "600",
      fontSize: "12px !important",
      textAlign: "left",
      width: "calc(100% - 110px)",
      paddingRight: "-50px",
      ...defaultInputAppearance,
      "& div": {
        paddingTop: "0px",
        borderBottom: "1px solid #000000",
        marginTop: "0px !important",
        lineHeight: "1.1",
        fontSize: "12px !important",
        width: "100%",
      },
      display: "inline-flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    textField: {
      width: "100%",
    },
    galleryEditiorTextField: {
      width: "100%",
      '& div input::after':{
        display: 'none'
      }
      
    },
    DatePicker: {
      width: "100%",
    },
    gallery_password_visibility_icon: {
      color: "#7A7A7A",
      fontSize: "20px",
      margin: "0px",
      width: "100%",
      bottom: 2,
      position: 'relative'
    },
    photoDescriptionTextBox: {
      padding: 10,
      height: 100,
      fontSize: 12,
      width: '100%',
      overflow: 'scroll',
      margin: '10px 20px',
      border: 'solid 1px #000'
    },
    photoArtImgWrapper: {
      width: '100%',
      height: '100%',
      margin: 'auto',
      display: 'flex',
      marginBottom: 0,
      aspectRatio: '3/2',
      overflow: 'hidden',
      textAlign: 'center',
      justifyContent: 'center'
    },
    photoArtImg: {
      padding: 10,
      width: '100%',
      border: 'none',
      margin: 'auto',
      height: '100%',
      maxWidth: '85%',
      maxHeight: '85%',
      objectFit: 'cover',
      border: 'dashed 1px #000'
    },
    chips: {
      display: "flex",
      flexWrap: "wrap",
      width: "100%",
      gap: "3px",
      maxWidth: "200px",
      minWidth: "194px",
      padding: "0px 4px",
    },
    secondSection: {
      marginRight: "25px",
    },
    chip: {
      height: "20px",
    },
    fieldLabelAndValueWrapper: {
      margin: 0,
      padding: "3px 0",
      borderBottom: "1px dashed #e6eef7",
      "&:last-child": {
        borderBottom: "none",
      },
    }
  }
};

export default sidebarStyle;
